<template>
  <path
    d="M4.78 15.2703L7.32 14.9803C7.93 14.9103 8.53 15.1203 8.96 15.5503L10.8 17.3903C13.63 15.9503 15.95 13.6403 17.39 10.8003L15.54 8.95026C15.11 8.52026 14.9 7.92026 14.97 7.31026L15.26 4.79026C15.38 3.78026 16.23 3.02026 17.25 3.02026H18.98C20.11 3.02026 21.05 3.96026 20.98 5.09026C20.45 13.6303 13.62 20.4503 5.09 20.9803C3.96 21.0503 3.02 20.1103 3.02 18.9803V17.2503C3.01 16.2403 3.77 15.3903 4.78 15.2703Z"
  />
</template>
